<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="title-wrapper">
            <div>
                <h1 class="title-default">{{ isEdicao ? 'Editar Unidade de Medida' : 'Nova Unidade de Medida' }}
                </h1>
                <p class="welcome-message">
                    <button mat-icon-button (click)="voltar()">
                        <mat-icon>arrow_back</mat-icon>
                    </button>
                    {{ isEdicao ? 'Edição' : 'Cadastro' }} de uma {{ isEdicao ? '' : 'nova' }} unidade de medida no
                    sistema.
                </p>
            </div>
        </div>

        @if(isLoading) {
        <div class="col-12">
            <app-loading-box height="200"></app-loading-box>
        </div>
        } @else {
        <div class="col-12">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col-md-6 col-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Unidade de Medida</mat-label>
                            <input matInput formControlName="descricao" placeholder="Ex: Quilograma" required>
                            @if (form.get('descricao')?.hasError('required')) {
                            <mat-error>A descrição é <strong>obrigatória</strong></mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-4 col-12">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Abreviação</mat-label>
                            <input matInput formControlName="abreviacao" placeholder="Ex: KG" required>
                            <mat-icon matSuffix
                                matTooltip="Informe aqui a abreviação para a unidade de medida cadastrada. Ex. digite &quot;kg&quot; para quilograma."
                                matTooltipPosition="above"
                                style="color: #888; cursor: pointer; font-size: 20px;">help_outline</mat-icon>
                            @if (form.get('abreviacao')?.hasError('required')) {
                            <mat-error>A abreviação é <strong>obrigatória</strong></mat-error>
                            }
                        </mat-form-field>
                    </div>
                    <div class="col-md-2 col-12 d-flex align-items-center">
                        <mat-slide-toggle class="app-toggle-compact mb-3" formControlName="isFracionada">
                            Fracionada
                        </mat-slide-toggle>
                    </div>
                </div>

            </form>
        </div>
        }
    </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>
